<template>
  <div class='ExportCard'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle"
                 :searchHandleSpan="search.searchHandleSpan">
    </search-form>
    <Table :TableParam="Table">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:shop="{ item }">
        <div>{{ item.shop }}</div>
        <div>{{ item.shopCode }}</div>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'

const typeProps = { label: 'name', value: 'id' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '店铺：', prop: 'shopName', placeholder: '请输入店铺' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: typeProps, change: row => '', placeholder: '请选择卡类型' },
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },  
          { type: 'Input', label: '批次号：', prop: 'cardBatchSn', placeholder: '请输入批次号' },  
          { type: 'daterange', label: '消费时间：', prop: 'daterange', span: 12 },
          { type: 'Select', label: '发行方式：', prop: 'issuingType', placeholder: '请选择发行方式', options: this.$label.SendTypes }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ],
        searchHandleSpan: 8  
      },
      multipleSelection: [], // 选中的
      Table: { // 表格
        defaultBtn: {
          show: true,
          html: '导出',
          handle: () => this.defaultEvent()
        },
        data: [],
        column: [
          { prop: 'orderTime', label: '交易日期' },
          { prop: 'orderNo', label: '流水号' },
          { prop: 'shop', label: '店铺', slot: true },
          { prop: 'cardType', label: '卡类型' },
          { prop: 'issuingType', label: '发行方式', slot: true },
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardNo', label: '预付卡号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'consumeAmount', label: '核销金额' },
          { prop: 'feeAmount', label: '手续费' },
          { prop: 'refundAmount', label: '返款额' }
        ]
      }
    }
  },
  created(){
    this.getCardTypeList()
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      this.getItemList()
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            // this.asyncData.cardTypeList = res.data
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('卡类型')) {
                item.options = res.data
              }
            })
          }
        })
    },
    searchResetForm () {
      this.search.searchData = {}
    },
    // 列表
    getItemList () {
      const { daterange } = this.search.searchData
      const { pager, Table } = this
      if (!daterange) {
        this.$message.warning('请选择消费日期')
        return
      }
      const params = this.setParams()
      this.$http.getRateDetailList(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res.data.total
            Table.data = res.data.list
            if(this.Table.data.length) {
              if(this.Table.data[this.Table.data.length - 1].account === '合计') {
                this.Table.data.pop()
              }else {
                this.rateDetailSum()
              }
            }
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    // 导出
    defaultEvent () {
      const { daterange } = this.search.searchData
      if (!daterange) {
        this.$message.warning('请选择消费日期')
        return
      }
      const params = this.setParams()
      this.$http.defaultRateDetailList(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    // 合计
    rateDetailSum () {
      const { daterange } = this.search.searchData
      if (!daterange) {
        this.$message.warning('请选择消费日期')
        return
      }
      const params = this.setParams()
      this.$http.rateDetailSum(params)
        .then((res) => {
          let data = JSON.parse(JSON.stringify(res.data))
          data.orderTime = '合计'
          this.Table.data.push(data)
        })
    },
    setParams () {
      const { shopName, daterange ,cardTypeId, cardName, cardBatchSn, issuingType } = this.search.searchData
      const { pager } = this
      return {
        pageNum: pager.page,
        pageSize: pager.rows,
        'periodParam.beginDate': daterange ? daterange[0] : null,
        'periodParam.endDate': daterange ? daterange[1] : null,
        shopName,
        cardTypeId,
        cardName,
        cardBatchSn,
        issuingType
      }    
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
